import React from 'react';
import FaqLists from '../FaqLists/FaqLists';
import FaqTitle from '../FaqTitle/FaqTitle';
import classes from "./Faq.module.css";

export default function Faq() {
  return (
    <section className={classes.faq} id="faq">
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <FaqTitle />
                </div>
                <div className="col-md-12">
                <FaqLists />
                </div>
            </div>
        </div>
    </section>
  )
}
